import "./Projects.css";

const Projects = () => {
  return (
    <section className="projects" id="projects">
      <div className="projects-container">

        <span className="projects-tag">Our Portfolio</span>

        <h2>Projects Coming Soon</h2>

        <p>
          We are currently curating our portfolio of completed homes.
          This section will soon showcase our latest interior transformations,
          design concepts, and client spaces.
        </p>

        <p className="projects-note">
          Stay tuned — exciting projects are on the way ✨
        </p>

        <a href="/contact#contact" className="projects-btn">
          Discuss Your Project
        </a>

      </div>
    </section>
  );
}

export { Projects };